export const errorMessages = {
  'Error creating WebGL context.':
    'Your browser does not have WebGL enabled. Please try a different browser, update your current browser or enable WebGL in your browser settings.',
}
